export default {
  inheritAttrs: false,
  props: {
    // Display card in simple mode (not used on main timeline element)
    simple: {
      type: Boolean,
      default: false
    },
    // Display full date of the entry on the card
    fullDate: {
      type: Boolean,
      default: false
    },
    // Display the card in a compacted / slim mode
    slim: {
      type: Boolean,
      default: false
    },
    // Force the card into read-only mode
    readOnly: {
      type: Boolean,
      default: false
    },
    // Disable pinning the element but don't treat it as read-only mode
    disablePinning: {
      type: Boolean,
      default: false
    }
  }
}
